/* FÉNIX R08.01 — runtime stability: one mobile-nav authority + state sync. */
(function(){
  'use strict';
  var root=document.documentElement;

  function detachLegacyMobileNav(){
    if(!window.jQuery)return;
    try{
      /* theme.js todavía registra slideToggle sobre estos mismos controles.
         Se retira sólo el handler jQuery; la autoridad nativa FÉNIX permanece. */
      window.jQuery('#MobileNavTrigger').off('click');
      window.jQuery('#MobileNav .mobile-nav__sublist-trigger').off('click');
      var nav=document.getElementById('MobileNav');
      if(nav){
        nav.style.removeProperty('display');
        nav.style.removeProperty('height');
        nav.style.removeProperty('padding-top');
        nav.style.removeProperty('padding-bottom');
      }
    }catch(e){}
  }

  function syncThemeLabels(){
    if(!root)return;
    var light=(root.getAttribute('data-nm-theme')||root.getAttribute('data-theme'))==='light';
    var label=light?'Modo oscuro':'Modo claro';
    document.querySelectorAll('.nm-theme-toggle').forEach(function(button){
      button.setAttribute('title',label);
      button.setAttribute('aria-label',label);
      var spans=button.querySelectorAll('span:not(.nm-theme-icon)');
      spans.forEach(function(span){ span.textContent=label; });
    });
  }

  function schedule(){
    detachLegacyMobileNav();
    syncThemeLabels();
    window.setTimeout(detachLegacyMobileNav,0);
    window.setTimeout(detachLegacyMobileNav,120);
    window.setTimeout(detachLegacyMobileNav,420);
  }

  if(root&&window.MutationObserver){
    new MutationObserver(function(){ syncThemeLabels(); }).observe(root,{attributes:true,attributeFilter:['data-nm-theme','data-theme']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  window.addEventListener('pageshow',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
})();

/* FÉNIX R08.02 — MOBILE MENU HITBOX GUARD
   Si una autoridad histórica estira el enlace del logo sobre el área visual del
   hamburger, cancela la navegación a HOME y reenvía el gesto al botón real. */
(function(){
  'use strict';
  var root=document.documentElement;
  if(!root||root.dataset.fnxR08MenuHitboxGuard==='1')return;
  root.dataset.fnxR08MenuHitboxGuard='1';
  var redispatching=false;

  function mobile(){
    return !!(window.matchMedia&&window.matchMedia('(max-width:1140px)').matches);
  }

  function harden(){
    var trigger=document.getElementById('MobileNavTrigger');
    if(!trigger)return;
    trigger.setAttribute('type','button');
    trigger.setAttribute('aria-controls','MobileNav');
    trigger.style.setProperty('pointer-events','auto','important');
    trigger.style.setProperty('z-index','80','important');
    var header=trigger.closest&&trigger.closest('.nm-mobile-header');
    if(header){
      header.style.setProperty('position','relative','important');
      header.style.setProperty('z-index','50','important');
      header.style.setProperty('pointer-events','auto','important');
    }
  }

  function inside(rect,x,y){
    return rect&&rect.width>=24&&rect.height>=24&&x>=rect.left&&x<=rect.right&&y>=rect.top&&y<=rect.bottom;
  }

  /* Fallback de coordenadas: sólo actúa si el tap cayó físicamente dentro del
     rectángulo del botón pero otro elemento recibió el evento. */
  document.addEventListener('click',function(event){
    if(redispatching||!mobile())return;
    var target=event.target;
    if(target&&target.closest&&target.closest('#MobileNavTrigger'))return;
    var trigger=document.getElementById('MobileNavTrigger');
    if(!trigger)return;
    var rect=trigger.getBoundingClientRect();
    if(!inside(rect,event.clientX,event.clientY))return;

    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation)event.stopImmediatePropagation();

    redispatching=true;
    try{ trigger.click(); }catch(e){}
    redispatching=false;
  },true);

  function schedule(){
    harden();
    window.setTimeout(harden,0);
    window.setTimeout(harden,160);
    window.setTimeout(harden,500);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
  window.addEventListener('pageshow',schedule,{passive:true});
  window.addEventListener('resize',harden,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
})();
